import React from 'react';
import PropTypes from 'prop-types';
import { COLORS } from '../../../styles/constants';

const PartCountLabel = ({ count }) => {
	return <span style={{ color: COLORS.TEXT_SECONDARY }}>({count})</span>;
};

PartCountLabel.propTypes = {
	count: PropTypes.number.isRequired
};

export default PartCountLabel;
